export default [
  {
    path: "/ebys/gelen",
    name: "ebys-gelen",
    component: () => import("./gelen/index.vue"),
    meta: {
      pageTitle: "ebys.Gelen Evraklar",
      breadcrumb: [
        {
          text: "EBYS",
          active: false,
        },
        {
          text: "ebys.Gelen Evrak",
          active: true,
        },
      ],
      yetki: { k: [1130002] },
    },
  },
  {
    path: "/ebys/giden",
    name: "ebys-giden",
    component: () => import("./giden/index.vue"),
    meta: {
      pageTitle: "ebys.Giden Evraklar",
      breadcrumb: [
        {
          text: "EBYS",
          active: false,
        },
        {
          text: "ebys.Giden Evrak",
          active: true,
        },
      ],
      yetki: { k: [1130002] },
    },
  },
  {
    path: "/ebys/ic",
    name: "ebys-ic",
    component: () => import("./giden/index.vue"), // Şimdilik giden/index yapısı kullanılabilir, parametre ile ayrışır
    meta: {
      pageTitle: "ebys.İç Yazışma",
      breadcrumb: [
        {
          text: "EBYS",
          active: false,
        },
        {
          text: "ebys.İç Yazışma",
          active: true,
        },
      ],
      yetki: { k: [1130002] },
    },
  },
  {
    path: "/ebys/yeni",
    name: "ebys-yeni",
    component: () => import("./form/index.vue"),
    meta: {
      pageTitle: "Yeni Evrak Oluştur",
      breadcrumb: [
        {
          text: "EBYS",
          active: false,
        },
        {
          text: "ebys.Yeni Evrak",
          active: true,
        },
      ],
      yetki: { k: [1130003] }, // Gelen evrak kayıt yetkisi default, form içinde ayrışacak
    },
  },
  {
    path: "/ebys/duzenle/:uuid",
    name: "ebys-duzenle",
    component: () => import("./form/index.vue"),
    meta: {
      pageTitle: "ebys.Evrak Düzenle",
      breadcrumb: [
        {
          text: "EBYS",
          active: false,
        },
        {
          text: "Düzenle",
          active: true,
        },
      ],
      yetki: { k: [1130006] },
    },
  },
  {
    path: "/ebys/detay/:uuid",
    name: "ebys-detay",
    component: () => import("./detay/index.vue"),
    meta: {
      pageTitle: "Evrak Detayı",
      breadcrumb: [
        {
          text: "EBYS",
          active: false,
        },
        {
          text: "Detay",
          active: true,
        },
      ],
      yetki: { k: [1130002] },
    },
  },
]
